import { render, staticRenderFns } from "./IndividualDocumentsDemo.vue?vue&type=template&id=71eeb50a&scoped=true"
import script from "./IndividualDocumentsDemo.vue?vue&type=script&lang=js"
export * from "./IndividualDocumentsDemo.vue?vue&type=script&lang=js"
import style0 from "./IndividualDocumentsDemo.vue?vue&type=style&index=0&id=71eeb50a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eeb50a",
  null
  
)

export default component.exports